import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { WastedSamplesPage } from "@/features/quality/components/wasted/wasted-samples-page";

const search = z.object({
  tab: z.enum(["pending", "decided"]).default("pending"),
});

/** Damaged/Consumed samples: the QC supervisor approves a replacement or rejects the report (QC fail rules, Phase 2). */
export const Route = createFileRoute("/_app/quality/damaged-samples/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.verify")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <WastedSamplesPage
      tab={tab}
      onTab={(t) => void navigate({ search: (prev) => ({ ...prev, tab: t }) })}
    />
  );
}
